export default __webpack_public_path__ + "static/media/roboweldar.99524830.md";